// Shared game rules so the live game and the archive practice mode play identically.
// Heart pool persists across a whole run (see UserState.Hearts on the backend): built up by
// completing puzzles and committing words, drained by wrong guesses.
export const STARTING_HEARTS = 6;
export const MAX_HEARTS = 8;
export const WRONG_WORD_PENALTY = 2;

// Momentum meter: rewards patient, accurate play. Each correct letter adds MOMENTUM_LETTER and
// each correct word commit adds MOMENTUM_WORD; any wrong guess resets the meter to 0. Momentum
// carries across puzzles within a run and drives an XP multiplier on completion.
export const MOMENTUM_LETTER = 1;
export const MOMENTUM_WORD = 5;

// Momentum -> XP multiplier tiers, highest first. Mirrored in UserState.XpMultiplier on the
// backend (which actually applies it to earned XP); keep the thresholds in sync, like SERIES_LENGTH.
export const MOMENTUM_TIERS = [
    {threshold: 45, multiplier: 3},
    {threshold: 30, multiplier: 2.5},
    {threshold: 18, multiplier: 2},
    {threshold: 8, multiplier: 1.5},
    {threshold: 0, multiplier: 1},
];

export function momentumMultiplier(momentum) {
    return MOMENTUM_TIERS.find(tier => momentum >= tier.threshold).multiplier;
}

// The momentum at which the next multiplier tier unlocks, or null at the cap. Used to draw the
// meter's progress toward the next tier.
export function nextMomentumThreshold(momentum) {
    const higher = MOMENTUM_TIERS.filter(tier => tier.threshold > momentum);
    return higher.length ? higher[higher.length - 1].threshold : null;
}

// Soft cap on a run: reaching this many cleared puzzles completes the series. Set high
// enough that nobody realistically gets there, so the run plays as effectively endless
// (a run ends when hearts hit zero). Mirrors UserState.SeriesLength on the backend, where
// puzzles are generated lazily up to this cap.
export const SERIES_LENGTH = 200;
